import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';
import { BrowserFrame, CheckList, DemoCaption } from '../compass/shared';

// Section 5 — two honest views of the same data: the salesperson's own
// dashboard and the manager's team dashboard.
export const ReachDashboards = ({ sp }) => (
  <section aria-labelledby="reach-dashboards-heading" data-testid="reach-dashboards" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="05"
        eyebrow="Dashboards"
        title="Your book at a glance — and your team's"
        description={sp.dashboardsCopy}
        testid="reach-dashboards-header"
      />

      <div className="mt-14 grid items-center gap-10 lg:grid-cols-[1.4fr_1fr]">
        <Reveal>
          <BrowserFrame shot={sp.shots.dashboard} label="Amden Reach — personal dashboard" data-testid="reach-personal-visual" />
          <DemoCaption />
        </Reveal>
        <Reveal delay={0.1}>
          <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">My dashboard</h3>
          <p className="mt-2 text-base font-extrabold tracking-tight text-navy-900">What needs my attention today</p>
          <div className="mt-4">
            <CheckList items={sp.personalPoints || []} testid="reach-personal-points" />
          </div>
        </Reveal>
      </div>

      <div className="mt-20 grid items-center gap-10 lg:grid-cols-[1fr_1.4fr]">
        <Reveal className="lg:order-2">
          <BrowserFrame shot={sp.shots.teamDashboard} label="Amden Reach — team dashboard" data-testid="reach-team-visual" />
          <DemoCaption />
        </Reveal>
        <Reveal delay={0.1} className="lg:order-1">
          <h3 className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">Team dashboard</h3>
          <p className="mt-2 text-base font-extrabold tracking-tight text-navy-900">What the whole team is doing</p>
          <div className="mt-4">
            <CheckList items={sp.teamPoints || []} testid="reach-team-points" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
